<template>
    <div class="content">
        <div class="content-left">
            <div v-for="resource in collection" v-bind:key="resource.projectId" class="list-row-page">
                <div class="list-columns">
                    <div>
                        <custom-checkbox v-bind:ref="resource.refName" v-bind:id="resource.projectId" v-bind:letter="firstLetter(resource.name)" v-on:change="selectItem(resource, $event)" ></custom-checkbox>
                    </div>
                    <div >{{ resource.name }}</div>
                </div>
                <div class="list-item-tools"> 
                    <v-btn flat icon small  v-on:click="deleteEntry(resource.deleteHref)"><v-icon size="19px" color="#616161">delete</v-icon></v-btn>
                </div>
            </div>
        </div>
        <div class="sidebar-right">
            <v-autocomplete  v-model="selectedProjectId" 
            :items="foundProjects" 
            :loading="isLoadingProjects" 
            :search-input.sync="searchProject" 
            item-text="name" 
            item-value="projectId" 
            :label="$t('message.Project')"
            :no-data-text="$t('message.ajaxAutoComplete')" ></v-autocomplete>
            <v-btn v-on:click="assignProject" >Add</v-btn>
        </div>
    </div>
</template>


<script>
import ProjectRepository from "../../services/ProjectRepository.js";
import HAL from "../../helpers/HAL.js";
import GenericRepository from "../../services/GenericRepository.js";
import CustomCheckbox from "../primitive_componets/CustomCheckbox.vue";

export default {
  name: "MemberProjectsPage",
  data() {
    return {
      selectedProjectId: null,
      foundProjects: [],
      isLoadingProjects: false,
      searchProject: null,
      collection: [],
      next: null,
      insertLink: ""
    };
  },
  components: {
    CustomCheckbox
  },
  props: {
    projectsLink: String
  },
  methods: {
    firstLetter(a) {
      if (a && a.length > 0) {
        return a.charAt(0);
      }
      return "";
    },
    selectItem(value) { return value; },
    assignProject() {
      
      if (!this.insertLink) return;

      if(this.selectedProjectId <= 0) return;

      let crtData = {
          "projectId": this.selectedProjectId
      };

      GenericRepository.insert(this.insertLink, crtData).then(response => {
        if (response.data.status == "Success") {
          this.selectedProjectId = null;
          this.load();
        }
      });
    },
    load() {
      if (!this.projectsLink) return;

      

      GenericRepository.getCollection(this.projectsLink).then(response => {
        if (response.data.status == "Success") {
          let items = HAL.getEmbededResources(
            response.data,
            "help:member-project"
          );
          this.collection = [];
          for (let i in items) {
            items[i].refName = "mProjects_" + items[i].projectId;
            items[i].deleteHref = null;
            this.collection.push(items[i]);
          }
        }
        let crtLnk =  HAL.getSelfLink(response.data);
        this.insertLink = crtLnk ? crtLnk.replace('/0/25', '') : null;

        //this.next = HAL.getLink(response.data, "help:member-list", "Next");
      });
    },
    deleteEntry(link) {
      if (link) {
        if (confirm(this.$t("message.DeleteDialogMessage")) == true) {
          GenericRepository.deleteEntity(link).then(
            function(response) {
              if (response.data.status == "Success") {
                this.load();
              }
            }.bind(this)
          );
        }
      }
    }
  },
  created() {
    this.load();
  },
  watch: {
    projectsLink(value) {
      if (!value) return;

      this.load();
    },
    searchProject(value) {
      if (!value || value.length < 3) return;

      if (this.isLoadingProjects) return;

      this.isLoadingProjects = true;

      ProjectRepository.search(value)
        .then(response => {
          this.foundProjects = HAL.getEmbededResources(
            response.data,
            "help:project"
          );
        })
        .finally(() => (this.isLoadingProjects = false));
    }
  }
};
</script>

<style scoped>
.list-row-page {
    line-height: 30px;
    background-color: #fff;
    padding: 6px 24px;
    font-size: 13px;
    display: flex;
    height: 44px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #efefef;
}

.list-row-page:hover > .list-item-tools {
    display: block;
}

</style>


